import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  ${({ theme }) => theme?.fontUrl && `
    @font-face {
      font-family: '${theme.fontName || "CustomFont"}';
      src: url('${theme.fontUrl}') format('woff');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `}
  :root {
    --cdv-font-style: ${props => props.theme?.fontName ? `'${props.theme.fontName}'` : `'Roboto'`};
  }

  #cdv-widget,
  #cdv-widget * {
    font-family: ${props =>
      props.theme?.fontUrl
        ? `'${ props.theme.fontName || "CustomFont"}'`
        : `'Roboto'`}, Arial, sans-serif !important;
  }

  #cdv-widget {
    --cdv-font: ${({ theme }) => theme?.colors?.font || '#111'};
    --cdv-widget-bg: ${({ theme }) => theme?.colors?.widgetBg || '#fff'};
    --cdv-header-bg:${({ theme }) => theme?.colors?.headerBg || '#fff'};
    --cdv-btn-bg: ${({ theme }) => theme?.colors?.btnBg || '#0aa'};
    --cdv-header-text:${({ theme }) => theme?.colors?.headerfont || '#111'};
    --cdv-separator:${({ theme }) => theme?.colors?.separator || '#0aa'};
    --cdv-btn-text: ${({ theme }) => theme?.colors?.btnText || '#fff'};
    --cdv-radius-btn: ${({ theme }) => (theme?.radii?.btn ?? "10px")};
    --cdv-filter-font:${({ theme }) => theme?.colors?.filterFont || '#111'};

  
    --RaisinBlack: var(--cdv-font);
    --Cyan: var(--cdv-btn-bg);
    --Teal: var(--cdv-btn-bg);
    --White: #ffffff;
  }
`;
